import {createSlice} from '@reduxjs/toolkit';
import {httpPost, httpPostCore} from '../../util/Rest';

const initialData = {
  token: null,
  userid: null,
  logInStatus: null,
  resetPassword: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  changePasswordStatus: null,
  expiryDate: null,
  errorValue: null
};

const slice = createSlice({
  name: 'login',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    postUserData: (state, action) => {
      state.logInStatus = action.payload.status;
      state.userid = action.payload.response.userId;
      state.token = action.payload.response.token;
      state.expiryDate = action?.payload?.response?.passwordExpiryDate;
      state.isLoading = false;
      state.errorMsg = action?.payload?.data?.message;
      state.successMsg = action?.payload?.message;
    },
    postResetPassword: (state, action) => {
      state.changePasswordStatus = action?.payload?.data?.success;
      state.isLoading = false;
      state.errorValue = action?.payload?.data?.value;
      state.errorMsg = action?.payload?.data?.success ? '' : action?.payload?.data?.message;
      state.successMsg = !action?.payload?.data?.success ? '' : action?.payload?.data?.message;
    },
    resetlogIn: (state) => {
      state.logInStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.message ? action.payload.data.message : '';
      state.isLoading = false;
    },
    resetSuccess: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
    resetPasswordMsg: (state) => {
      state.resetPassword = null;
      state.changePasswordStatus = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {
  postUserData,
  fetchStart,
  resetlogIn,
  resetSuccess,
  fetchError,
  postResetPassword,
  resetPasswordMsg,
} = slice.actions;

export const postLogIn = (details) => {
  console.log("... still calling it wrong...src/redux/reducers/Login.js..");
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`authenticate`, details)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          // dispatch(fetchError(data));
          dispatch(postUserData(data));
          sessionStorage.setItem('userRoles', JSON.stringify({userRoles: data?.response?.roles}));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchResetPassword = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPostCore(`users/changepass`, details)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          // dispatch(fetchError(data));
          dispatch(postResetPassword(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetMsg = () => {
  return (dispatch) => {
    dispatch(resetSuccess());
  };
};
export const resetlogInStatus = () => {
  return (dispatch) => {
    dispatch(resetlogIn());
  };
};
export const resetPasswordStatus = () => {
  return (dispatch) => {
    dispatch(resetPasswordMsg());
  };
};
